import { Step as StepProps } from '@service-victoria/component-library/components/Wizard/props';
import React from 'react';

import * as Interfaces from 'app/interfaces';
import * as Steps from '..';
import { constants, storage } from 'app/utils';

const Component = React.lazy(() => import('./Done'));

const Step: StepProps<Interfaces.Common.RedemptionFormValues> = {
  id: 'done',
  title: constants.RedemptionPage.title,
  stepName: 'Done',
  Component,
  navigation: {
    normal: [
      {
        content: 'Redeem another',
        shouldValidate: false,
        type: 'secondary',
        onClick: async (context, formProps) => {
          const redemptionType = formProps.values.redeem.redemptionType;

          // Reset form, except for: redemption type (ie. individual or bulk) and logged in user
          formProps.resetForm();
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: Steps.Redeem.Select.Step.id,
            values: {
              ...formProps.initialValues,
              redeem: {
                ...formProps.initialValues.redeem,
                redemptionType
              }
            }
          });
        }
      },
      {
        content: 'Done',
        shouldValidate: false,
        type: 'primary',
        onClick: async (_, formProps): Promise<void> => {
          formProps.setValues({} as never, false);

          storage.deleteItem(constants.RedemptionStorageKeys.Wizard);
          storage.deleteItem(constants.RedemptionStorageKeys.State);

          setTimeout(() => {
            // Navigate back to dashboard
            window.location.href = `${import.meta.env.BASE_URL}${constants.Routes.Dashboard}`;
          }, 0);
        }
      }
    ]
  }
};

export { Step };
